module.exports = __webpack_public_path__ + "img/Profil_SB-ab-2008.90fb6cfe.jpg";